export default function ProjectScreenSkeleton() {
  return (
    <div className="flex flex-col bg-neutral-100 overflow-auto max-h-screen">
      {/* Blue indeterminate loading bar */}
      <div className="fixed top-0 left-0 right-0 z-50 h-0.5 bg-blue-100 overflow-hidden">
        <div
          className="h-full bg-blue-500 rounded-full"
          style={{ width: "45%", animation: "skeleton-bar 1.4s ease-in-out infinite" }}
        />
      </div>

      <style>{`
        @keyframes skeleton-bar {
          0%   { transform: translateX(-120%); }
          100% { transform: translateX(280%); }
        }
      `}</style>

      <div className="flex flex-col h-fit pb-96 mt-10 ml-10 mr-10">
        <div className="flex flex-col w-full max-w-1p2k">

          {/* Header */}
          <div className="flex flex-row w-full justify-start mb-10">
            <div className="flex flex-col w-fit mr-4 gap-2">
              {/* Breadcrumb */}
              <div className="h-4 w-16 rounded bg-neutral-200 animate-pulse" />
              {/* Title */}
              <div className="h-8 w-64 rounded-lg bg-neutral-200 animate-pulse" />
              {/* Status blocks */}
              <div className="flex flex-row gap-2 mt-1">
                <div className="h-6 w-32 rounded-full bg-neutral-200 animate-pulse" />
                <div className="h-6 w-28 rounded-full bg-neutral-200 animate-pulse" />
              </div>
            </div>

            {/* Project photo */}
            <div className="h-28 w-56 rounded-3xl bg-neutral-200 animate-pulse mr-auto" />
          </div>

          {/* Tabs bar */}
          <div className="flex flex-row gap-2 mb-4">
            {[96, 64, 72, 88, 72, 72].map((w, i) => (
              <div
                key={i}
                className="h-9 rounded-xl bg-neutral-200 animate-pulse"
                style={{ width: w }}
              />
            ))}
          </div>

          {/* Main content + right sidebar */}
          <div className="flex flex-row gap-8 items-start mt-4">

            {/* Left — timeline skeleton */}
            <div className="flex flex-col flex-1 min-w-0 gap-4">
              {/* Search field */}
              <div className="h-10 w-full max-w-500 rounded-xl bg-neutral-200 animate-pulse" />

              {/* Timeline items */}
              {[...Array(4)].map((_, i) => (
                <div key={i} className="flex flex-row gap-3 items-start w-full max-w-500">
                  {/* dot + line */}
                  <div className="flex flex-col items-center pt-1 gap-1">
                    <div className="h-3 w-3 rounded-full bg-neutral-200 animate-pulse flex-shrink-0" />
                    {i < 3 && <div className="w-0.5 h-16 bg-neutral-200 animate-pulse" />}
                  </div>
                  {/* card */}
                  <div className="flex flex-col gap-2 flex-1 bg-white rounded-xl p-4 shadow-sm">
                    <div className="h-3 w-24 rounded bg-neutral-200 animate-pulse" />
                    <div className="h-4 w-48 rounded bg-neutral-200 animate-pulse" />
                    <div className="h-3 w-full rounded bg-neutral-200 animate-pulse" />
                  </div>
                </div>
              ))}
            </div>

            {/* Right sidebar */}
            <div className="flex flex-col gap-4 w-96 flex-shrink-0">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="bg-white rounded-xl p-4 shadow-sm flex flex-col gap-3">
                  {/* Card title */}
                  <div className="h-4 w-32 rounded bg-neutral-200 animate-pulse" />
                  {/* Card rows */}
                  {[...Array(3)].map((_, j) => (
                    <div key={j} className="flex flex-row gap-3 items-center">
                      <div className="h-4 w-4 rounded bg-neutral-200 animate-pulse flex-shrink-0" />
                      <div className="h-3 rounded bg-neutral-200 animate-pulse flex-1" />
                    </div>
                  ))}
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
